
 //function to handel the date is retrieved from the backend to display it in the correct way

export default function handelDate(givenDate) {
  const date = new Date(givenDate);
  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  });
  return formattedDate;
}
